const API_BASE = (process.env.NODE_ENV == 'production') ? (process.env.API_BASE || 'https://highway-api.track360.net.in/') : ((window.location.hostname.search("localhost") >= 0) ? 'http://localhost.theletstream.com:8053/' : 'https://e32proxier8005.theletstream.com/');
const AUTH_BASE = (process.env.NODE_ENV == 'production') ? (process.env.AUTH_BASE || 'https://highway-api.track360.net.in/') : ((window.location.hostname.search("localhost") >= 0) ? 'http://localhost.theletstream.com:8053/' : 'https://e32proxier8005.theletstream.com/');
const PORTAL_BASE = (process.env.NODE_ENV == 'production') ? (process.env.PORTAL_BASE || 'https://app.hwcsportal.com/') : ((window.location.hostname.search("localhost") >= 0) ? 'http://localhost.theletstream.com:8085/' : 'https://e32proxier8007.theletstream.com/');

const apiendpoints = {
    api_base: API_BASE,
    api_base_noslash: API_BASE.slice(0, -1),
    auth_base: AUTH_BASE,
    auth_base_noslash: AUTH_BASE.slice(0, -1),
    portal_base: PORTAL_BASE,
    portal_base_noslash: PORTAL_BASE.slice(0, -1),

    // Accounts
    login: AUTH_BASE + 'accounts/api/login/',
    logout: AUTH_BASE + 'accounts/api/logout/',
    forgot_password: AUTH_BASE + 'accounts/api/reset-password/',
    profile: AUTH_BASE + 'dashboard/profile/',
    get_users: API_BASE + 'dashboard/users/browse/',
    user_profile: API_BASE + 'accounts/user/',
    user_role: API_BASE + 'accounts/user/role/',

    // Notifications
    notifications_fcm: API_BASE + 'notifications/fcm/',

    // Custom
    organisations: `${API_BASE}organisation/list/`,
    organisation: `${API_BASE}organisation/`,
    user_organisations: `${API_BASE}organisation/my-organisations/`,
    organisation_user: `${API_BASE}organisation/user/`,
    organisation_users: `${API_BASE}organisation/users/`,

    data_issue: `${API_BASE}organisation/data/issue/`,
    data_issues: `${API_BASE}organisation/data/issues/`,
    admin_data_issues: `${API_BASE}organisation/data/admin/issues/`,

    data_issue_image: `${API_BASE}organisation/data/issue/%i/issue-image/`,

    data_asset_register: `${API_BASE}organisation/data/asset-register/`,
    data_asset_registers: `${API_BASE}organisation/data/asset-registers/`,

    data_asset_register_image: `${API_BASE}organisation/data/asset-register/%i/image/`,

    data_categories: `${API_BASE}organisation/data/categories/`,
    category_get: `${API_BASE}organisation/data/category/`,

    data_issues_types: `${API_BASE}organisation/data/issue-types/`,
    issue_type_get: `${API_BASE}organisation/data/issue-type/`,

    data_authority_types: `${API_BASE}organisation/data/authority-types/`,
    authority_type_get: `${API_BASE}organisation/data/authority-type/`,

    data_nature_of_accidents: `${API_BASE}organisation/data/nature-of-accidents/`,
    nature_of_accident_get: `${API_BASE}organisation/data/nature-of-accident/`,

    data_accident_classifications: `${API_BASE}organisation/data/accident-classifications/`,
    accident_classification_get: `${API_BASE}organisation/data/accident-classification/`,

    data_vehicle_types: `${API_BASE}organisation/data/vehicle-types/`,
    vehicle_type_get: `${API_BASE}organisation/data/vehicle-type/`,

    data_road_features: `${API_BASE}organisation/data/road-features/`,
    road_feature_get: `${API_BASE}organisation/data/road-feature/`,

    data_road_conditions: `${API_BASE}organisation/data/road-conditions/`,
    road_condition_get: `${API_BASE}organisation/data/road-condition/`,

    data_intersection_types: `${API_BASE}organisation/data/intersection-types/`,
    intersection_type_get: `${API_BASE}organisation/data/intersection-type/`,

    data_weather_conditions: `${API_BASE}organisation/data/weather-conditions/`,
    weather_condition_get: `${API_BASE}organisation/data/weather-condition/`,

    data_enroachment_types: `${API_BASE}organisation/data/enroachment-types/`,
    enroachment_type_get: `${API_BASE}organisation/data/enroachment-type/`,

    data_causes: `${API_BASE}organisation/data/causes/`,
    cause_get: `${API_BASE}organisation/data/cause/`,

    data_help_types: `${API_BASE}organisation/data/help-types/`,
    help_type_get: `${API_BASE}organisation/data/help-type/`,

    data_type_of_programs: `${API_BASE}organisation/data/type-of-programs/`,
    type_of_program_get: `${API_BASE}organisation/data/type-of-program/`,

    data_accident_types: `${API_BASE}organisation/data/accident-types/`,
    accident_type_get: `${API_BASE}organisation/data/accident-type/`,

    data_hazard_type: `${API_BASE}organisation/data/hazard-types/`,
    hazard_type_get: `${API_BASE}organisation/data/hazard-type/`,

    data_type_of_road: `${API_BASE}organisation/data/type-of-roads/`,
    type_of_road_get: `${API_BASE}organisation/data/type-of-road/`,

    data_issue_action: `${API_BASE}organisation/data/issue/%i/action/`,
    dpr_entry_issue_action: `${API_BASE}organisation/data/dpr/entry/%i/action/`,

    stock_list: `${API_BASE}organisation/stock/stocks/`,
    stock_get: `${API_BASE}organisation/stock/stock/`,

    stock_log_list: `${API_BASE}organisation/stock/stock/logs/`,
    stock_log_get: `${API_BASE}organisation/stock/stock/log/`,

    stock_categories: `${API_BASE}organisation/stock/categories/`,
    stock_subcategories: `${API_BASE}organisation/stock/sub-categories/`,
    stock_uoms: `${API_BASE}organisation/stock/units-of-measurement/`,

    dpr_reports: `${API_BASE}organisation/data/dpr/reports/`,
    dpr_packages: `${API_BASE}organisation/data/dpr/packages/`,
    dpr_package_keys: `${API_BASE}organisation/data/dpr/package-keys/`,

    dpr_month: `${API_BASE}organisation/data/dpr/month/`,
    dpr_daily: `${API_BASE}organisation/data/dpr/daily/`,

    dpr_month_action: `${API_BASE}organisation/data/dpr/month/%i/action/`,
    dpr_log_action: `${API_BASE}organisation/data/dpr/log/%i/action/`,

    // dpr logs
    dpr_log: `${API_BASE}organisation/data/dpr/log/`,
    dpr_log_list: `${API_BASE}organisation/data/dpr/logs/`,
    dpr_log_image: `${API_BASE}organisation/data/dpr/log/%i/dpr-log-image/`,

    // dpr entry
    dpr_entry: `${API_BASE}organisation/data/dpr/entry/`,
    dpr_entry_list: `${API_BASE}organisation/data/dpr/entries/`,
    dpr_entry_image: `${API_BASE}organisation/data/dpr/entry/%i/dpr-entry-images/`,

    //create excel
    excel_create: `${API_BASE}organisation/data/excel/create/`,
    excel_list: `${API_BASE}organisation/data/excel/list/`,

    // safety program
    safety_program: `${API_BASE}organisation/data/safety-program/`,
    safety_programs: `${API_BASE}organisation/data/safety-programs/`,
    safety_program_action: `${API_BASE}organisation/data/safety-program/%i/action/`,
    safety_program_image: `${API_BASE}organisation/data/safety-program/%i/safety-program-image/`,

    entries_report: `${API_BASE}organisation/data/entries/report/`,

    //notification
    notifications: `${API_BASE}organisation/notification/list/`,
    notification: `${API_BASE}organisation/notification/`,
    unread_notification: `${API_BASE}organisation/notification/unread-notification/`,

    admin_dashboard_stats_view1: `${API_BASE}organisation/stats/admin/dashboard/view1/`,
    admin_dashboard_stats_view2: `${API_BASE}organisation/stats/admin/dashboard/view2/`,
    admin_dashboard_stats_view3: `${API_BASE}organisation/stats/admin/dashboard/view3/`,

    // permission data
    permission_data: `${API_BASE}organisation/admin/permission-data/`,
    permission_role_create: `${API_BASE}organisation/admin/role/`,
    permission_role_list: `${API_BASE}organisation/admin/role/list/`,
}

export default apiendpoints
